import React from 'react'
const initialParentPosts =
[
    {
      "id": 1,
      "author": "Jane Smith",
      "date": "August 25th, 2022",
      "title": "After School Playdate/study session!",
      "body": "Hello fellow parents! I was thinking of gathering the class for a playdate at the park, and then maybe we could have a little learning activity after! This saturday is supposed to be gorgeous outside! Let me know if you'd like to set something up! :). ",
    },
    {
      "id": 2,
      "author": "Jonathan Warren",
      "date": "Sept 9th, 2022",
      "title": "Teacher Appreciation Party",
      "body": "Howdy y'all! I was thinking since the teachers have done such a superb job, we should throw them a little appreciation party! I'll be starting a list where other parents can volunteer to bring things for the party. Let me know if you'd like to help organize. Thank you."
    }
]

export default initialParentPosts